<div
  class="upsell-option relative border flex flex--column grow white-bg rounded-large overflow-hidden"
  [ngClass]="{
    wide: (isMobile$ | async) === true,
    'nordic-blue-900-bg': (isBVariant$ | async) === true && fareFamily.cabinClass !== FinnairCabinClass.BUSINESS,
    'business-dark-bg': (isBVariant$ | async) === true && fareFamily.cabinClass === FinnairCabinClass.BUSINESS
  }"
>
  <div [ngClass]="{ 'border-bottom': (isBVariant$ | async) === false }">
    <div
      *ngIf="(isBVariant$ | async) === false"
      class="fill flex pr-xsmall-x ps-small-y highlight top-bar top-banner nordic-blue-900-bg"
    >
      <span class="font-body-1 white-text flex flex--center medium-type">{{ 'upsell.title' | finLocalization }}</span>
    </div>
    <div
      *ngIf="(isBVariant$ | async) === true"
      class="fill pr-xsmall-x ps-small-y highlight top-bar top-banner white-text"
    >
      <div class="font-body-2 medium-type">{{ 'upsellCard.title' | finLocalization }}</div>
      <div class="flex ms-xsmall-t">
        <fcom-icon
          [name]="
            fareFamily.cabinClass === FinnairCabinClass.ECOPREMIUM ? 'pe-upgrade-outline' : 'business-upgrade-outline'
          "
          class="ms-xxsmall-t icon-large"
        ></fcom-icon>
        <div class="mr-xxsmall-l">
          <div class="medium-type">
            {{
              ('travelClass.' + fareFamily.cabinClass.toLowerCase() | finLocalization) ||
                ('travelClass.mixed' | finLocalization)
            }}
          </div>

          <div class="flex flex--middle flex--wrap">
            <span class="font-body-2 flex flex--middle ps-xxsmall-r">
              {{ 'pricesStartingFrom' | finLocalization }}
            </span>

            <span *ngIf="fareFamily.originalPrice" class="font-body-2 ps-xsmall-r strike-through">
              {{ { amount: fareFamily.originalPrice, currencyCode: currencyCode$ | async } | finPrice }}
            </span>

            <span class="font-heading-3 price">
              {{ { amount: fareFamily.price, currencyCode: currencyCode$ | async } | finPrice }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pr-xsmall-x pr-xsmall-b" [ngClass]="{ 'pr-xsmall-t': (isBVariant$ | async) === false }">
    <div
      class="ms-medium-b"
      [ngClass]="{ 'rounded-large overflow-hidden': (isBVariant$ | async) === true }"
      *ngIf="imageData$ | async as imageData"
    >
      <div class="relative">
        <fcom-image [imageData]="imageData" [ratio]="'1x1'"></fcom-image>
        <fcom-chip class="absolute avios-points ms-xsmall-l ms-xsmall-b" *ngIf="aviosPoints">
          <fcom-icon [name]="'avios-plectrum'" class="ms-xxsmall-r icon-small"></fcom-icon>
          <span>{{ 'avios.collectPointsTag' | finLocalization: { points: aviosPoints.toLocaleString() } }}</span>
        </fcom-chip>
      </div>
    </div>
    <div *ngIf="(isBVariant$ | async) === true">
      <span class="font-body-2 white-text">{{ descriptionKey$ | async | finLocalization }}</span>
    </div>
    <div *ngIf="(isBVariant$ | async) === false" class="border-bottom-dashed pr-xsmall-b">
      <span class="font-body-1 bold-type nordic-blue-900-text">
        {{
          ('travelClass.' + fareFamily.cabinClass.toLowerCase() | finLocalization) ||
            ('travelClass.mixed' | finLocalization)
        }}
      </span>
      <span class="flex flex--middle">
        <span class="nordic-blue-900-text font-body-2 ps-xsmall-r">
          {{ 'pricesStartingFrom' | finLocalization }}
        </span>

        <span *ngIf="fareFamily.originalPrice" class="nordic-blue-900-text font-body-2 ps-xsmall-r strike-through">
          {{ { amount: fareFamily.originalPrice, currencyCode: currencyCode$ | async } | finPrice }}
        </span>

        <span class="font-body-1 bold-type heather-700-text price">
          {{ { amount: fareFamily.price, currencyCode: currencyCode$ | async } | finPrice }}
        </span>
      </span>
      <div class="font-body-2 mr-xxsmall-t">
        {{ 'upsell.cabinClassDescription.' + fareFamily.cabinClass.toLowerCase() | finLocalization }}
      </div>
    </div>
    <fcom-button
      class="mr-small-y"
      [size]="ButtonSize.S_MEDIUM"
      [theme]="(isBVariant$ | async) === true ? ButtonTheme.SECONDARY : ButtonTheme.PRIMARY_BLUE"
      [mode]="ButtonMode.FILL"
      [icon]="{ category: 'svg-library', name: 'arrow-right', position: IconPosition.RIGHT }"
      [text]="'upsell.button' | finLocalization"
      (click)="selectNextCabinClass.emit(fareFamily)"
    >
    </fcom-button>
    <div class="align-center" *ngIf="(isBVariant$ | async) === true && (hideCabinClassModalLink$ | async) !== true">
      <a href class="white-text" (click)="emitOpenCabinClassModal($event, fareFamily.cabinClass)">{{
        'upsellCard.modalLink.' + fareFamily.cabinClass.toLowerCase() | finLocalization
      }}</a>
    </div>
  </div>
</div>
